import React from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { IMAGES, HIGHLIGHTS } from "../lib/site";
import { useSite, siteImg } from "../context/SiteContext";

export const Journey = () => {
  const site = useSite();
  const { scrollYProgress } = useScroll();
  const y = useTransform(scrollYProgress, [0, 1], [40, -60]);

  return (
    <section id="journey" data-testid="journey-section" className="py-24 md:py-32 lg:py-40 relative">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        {/* Live photo */}
        <motion.div
          initial={{ opacity: 0, clipPath: "inset(0 0 100% 0)" }}
          whileInView={{ opacity: 1, clipPath: "inset(0 0 0% 0)" }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1.1, ease: [0.76, 0, 0.24, 1] }}
          className="lg:col-span-7 relative overflow-hidden border border-white/[0.08]"
        >
          <motion.img
            style={{ y }}
            src={siteImg(site, "journey", IMAGES.livePhoto)}
            alt="Akalibe sur scène"
            className="w-full h-[420px] md:h-[560px] object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-base/70 via-transparent to-transparent" />
          <div className="absolute bottom-5 left-5 text-[10px] uppercase tracking-[0.3em] text-white/70 border border-white/20 px-3 py-1 backdrop-blur-sm">
            Live · Le Transbordeur, Lyon
          </div>
        </motion.div>

        {/* Highlights */}
        <div className="lg:col-span-5">
          <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-gold">Sur scène · Mon parcours</span>
          <h2 className="font-serif font-light text-4xl sm:text-5xl tracking-tight mt-4 mb-10 leading-tight">
            Là où tout <span className="gold-text">prend vie</span>.
          </h2>

          <div className="space-y-6">
            {HIGHLIGHTS.map((h, i) => (
              <motion.div
                key={`${h.year}-${h.text.slice(0, 16)}`}
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.1 }}
                data-testid={`highlight-${i}`}
                className="flex gap-5 border-t border-white/[0.06] pt-6"
              >
                <span className="font-serif text-gold text-lg tracking-wide shrink-0 w-24">{h.year}</span>
                <p className="text-[#B8B8B8] font-light leading-relaxed">{h.text}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
